export const supabaseConfig = {
  url: 'https://dwuytxqinmtgulpiuits.supabase.co',
  anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR3dXl0eHFpbm10Z3VscGl1aXRzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2OTg0NzgsImV4cCI6MjA1NDI3NDQ3OH0.RVasS8FAiO8pqUnSslrJA_zJ_Dbs8uRof7aUBQWXmnc'
} 